import { DOCUMENT, inject, Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { environment } from 'src/environments/environment';

import { ScriptInjectorService } from './script-injector.service';

const ANALYTICS_SCRIPT_ID = 'analytics-script';

declare global {
  interface Window {
    adobeDataLayer?: unknown[];
    _satellite?: {
      pageBottom?: () => void;
    };
  }
}

@Injectable({
  providedIn: 'root',
})
export class AnalyticsService {
  public initialized$ = new BehaviorSubject(false);

  private scriptInjectorService = inject(ScriptInjectorService);
  private document = inject<Document>(DOCUMENT);

  public async addAdobeLaunchScript(): Promise<void> {
    if (this.isAdobeLaunchScriptPresent()) {
      console.warn('Adobe Launch script is already present.');
      return;
    }

    try {
      window.adobeDataLayer = window.adobeDataLayer || [];

      await this.scriptInjectorService.load(
        ANALYTICS_SCRIPT_ID,
        environment.analyticsUrl
      );

      window._satellite?.pageBottom();

      this.initialized$.next(true);
    } catch (error) {
      console.error('Error while loading Adobe Launch Script', error);
      this.initialized$.next(false);
    }
  }

  public removeAdobeLaunchScript(): void {
    if (!this.isAdobeLaunchScriptPresent()) {
      return;
    }

    const script = this.document.getElementById(ANALYTICS_SCRIPT_ID);

    if (script) {
      script.remove();
    }

    if (window.adobeDataLayer) {
      delete window.adobeDataLayer;
    }

    this.initialized$.next(false);
  }

  private isAdobeLaunchScriptPresent(): boolean {
    return Boolean(this.document.getElementById(ANALYTICS_SCRIPT_ID));
  }
}
